import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar/AppBar';
import Toolbar from '@material-ui/core/Toolbar/Toolbar';
import Typography from '@material-ui/core/Typography';

const styles = {
  flex: {
    flex: 1,
  },
  toolbar: {
    marginLeft: 6,
    display: 'flex',
    alignItems: 'center',
    width: '100%',
  },
};

const Header = (props) => {
  const { className, classes, children } = props;

  return (
    <AppBar position="static" className={className}>
      <Toolbar>
        <div className={classes.toolbar}>
          <Typography
            variant="title"
            color="inherit"
          >
            Ad Mockup Generator - Display
          </Typography>
          {children}
        </div>
      </Toolbar>
    </AppBar>
  );
};

Header.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  children: PropTypes.element,
};

export default withStyles(styles)(Header);



// WEBPACK FOOTER //
// ./src/main/components/Header.jsx